<div>
  <app-number-input class="block mt-12 mb-10"
                    [value]="amount"
                    (valueChange)="amountChange.emit($event)"></app-number-input>
  <img src="./assets/evsb/img/charging-station-multiple-cars.png"
  class="ml-16 transform-gpu translate-x-10"/>
  <ng-content select="[start-button]"></ng-content>
</div>
